












































































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import FilterModal from "@/components/FilterModal.vue"; // @ is an alias to /src
import TabBar from "@/components/TabBar.vue";
import { API_BASE_URL, COLOUR_OPTIONS } from "@/shared/global-values";
import { formatDate, getDateRangeOfBudgetPeriod, groupExpensesByDate, countExpensesByColours } from "@/shared/utils";
import IExpense from "@/types/expense";
import IFilter from "@/types/filter";

export default Vue.extend({
  components: {
    FilterModal,
    TabBar,
  },
  data() {
    return {
      currentBudget: 0,
      budgetPeriod: "",
    };
  },
  computed: {
    totalAmount(): number {
      return this.expenses.reduce((acc: number, expense: IExpense) => {
        acc += expense.amount;
        return acc;
      }, 0);
    },
    isAlmostOverBudget(): boolean {
      const percent: number = this.totalAmount / this.currentBudget;
      return percent >= 0.75 && percent <= 1;
    },
    isFilterVisible(): boolean {
      return this.$store.getters.getIsFilterVisible;
    },
    isFiltered(): boolean {
      return this.$store.getters.getIsFiltered;
    },
    expenses(): IExpense[] {
      return this.$store.getters.getExpenses;
    },
    expensesGroupedByDate(): { [date: string]: IExpense[] } {
      return groupExpensesByDate(this.expenses);
    },
    expensesCountByColours(): { [colourHex: string]: number } {
      return countExpensesByColours(this.expenses);
    },
    filters(): IFilter {
      return this.$store.getters.getFilters;
    },
    header(): string {
      if (this.filters.dateFrom && this.filters.dateTo) {
        return `${formatDate(this.filters.dateFrom, "D MMM YY")} - ${formatDate(this.filters.dateTo, "D MMM YY")}`;
      }
      return "";
    },
  },
  methods: {
    toggleFilter(): void {
      this.$store.dispatch("toggleFilter");
    },
  },
  async created(): Promise<void> {
    const id: string = localStorage.getItem("userId") as string;

    try {
      const token: string = await firebase.auth().currentUser!.getIdToken();
      let response: AxiosResponse = await axios.get(`${API_BASE_URL}/users/${id}/budget_info`, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
      this.currentBudget = Number(response.data.currentBudget);
      this.budgetPeriod = response.data.budgetPeriod;

      if (!this.filters.dateFrom || !this.filters.dateTo) {
        const today: Date = new Date();
        const dateRangeOfBudgetPeriod = getDateRangeOfBudgetPeriod(today, this.budgetPeriod);
        this.$store.dispatch("setFilters", { dateFrom: dateRangeOfBudgetPeriod.dateFrom, dateTo: dateRangeOfBudgetPeriod.dateTo });
      }

      const params: URLSearchParams = new URLSearchParams();
      params.set("date_from", this.filters.dateFrom!.toISOString());
      params.set("date_to", this.filters.dateTo!.toISOString());

      response = await axios.get(`${API_BASE_URL}/expenses`, { params, withCredentials: true, headers: { Authorization: `Bearer ${token}` } });

      const expenses: IExpense[] = response.data.expenses.reduce((expenses: IExpense[], expense: IExpense) => {
        const colourOption = COLOUR_OPTIONS.find((option) => option.colour === expense.colour);
        expense.colourHex = colourOption!.hex;

        return [...expenses, expense];
      }, []);

      this.$store.dispatch("setExpenses", expenses);

    } catch (error) {
      console.error(error);
    }
  },
});
